module.exports = __webpack_public_path__ + "img/CinemaAin_Logo.1fa7f38c.png";